import React, { Component } from 'react';
import { BookingStateProperties } from '../../constants';
import { SELECT_PATIENT_STRINGS } from './constants';

/**
 * @param {string} appointmentTime
 * @param {string} emailErrorMessage
 * @param {string} locationId
 * @param {string} nameErrorMessage
 * @param {function(patientId: string): void} onPatientSelectionSuccess
 * @param {string} procedureId
 * @param {string} providerId
 * @param {boolean} showDateError
 * @param {function(): void} trackClickContinue
 * @param {function(): void} trackMePatientFieldSelect
 * @param {function(): void} trackNewSubPatientFieldSelect
 * @param {function(): void} trackExistingSubPatientFieldSelect
 * @returns {JSX.Element}
 * @constructor
 */
export class SelectPatientStateManager extends Component {
    state = {
        entityId: -1,
        mainPatientName: '',
        showSubPatient: false,
        subpatients: [],
    };

    componentWillReceiveProps(nextProps) {
        const {
            patientId,
            mainPatientFirstName,
            mainPatientLastName,
            subpatients,
            subpatientCreationSuccess,
            onPatientSelectionSuccess,
            subPatientPatientId,
        } = nextProps;

        if (patientId) {
            this.setState({
                entityId: parseInt(patientId, 10),
                mainPatientName: (mainPatientFirstName || '')
                    .concat(' ')
                    .concat(mainPatientLastName),
                subpatients,
            });
        }

        if (subpatientCreationSuccess) {
            onPatientSelectionSuccess(subPatientPatientId);
        }
    }

    handlePatientChange = (patient) => {
        const {
            trackExistingSubPatientFieldSelect,
            trackMePatientFieldSelect,
            trackNewSubPatientFieldSelect,
            setPatientAndInsuranceCard,
        } = this.props;

        const patientString = patient.toString();
        let newState;

        if (patientString === 'someoneElse') {
            newState = { showSubPatient: true };
            trackNewSubPatientFieldSelect();
        } else if (patientString) {
            if (patientString === this.state.entityId.toString()) {
                newState = { showSubPatient: false };
                trackMePatientFieldSelect();
            } else {
                newState = { showSubPatient: false };
                trackExistingSubPatientFieldSelect();
            }

            setPatientAndInsuranceCard(patientString);
        }

        this.setState(newState);
    };

    handleSubpatientCreated = (subpatientId) => {
        this.props.onPatientSelectionSuccess(subpatientId);
    };

    handleContinue = () => {
        const { onPatientSelectionSuccess, bookingState } = this.props;
        const chosenPatientId = bookingState[BookingStateProperties.patientId];

        this.props.trackClickContinue();
        onPatientSelectionSuccess(chosenPatientId);
    };

    render() {
        const {
            emailErrorMessage,
            nameErrorMessage,
            showDateError,
            providerId,
            locationId,
            procedureId,
            appointmentTime,
            trackClickContinue,
            trackMePatientFieldSelect,
            trackNewSubPatientFieldSelect,
            trackExistingSubPatientFieldSelect,
            mainPatientId,
        } = this.props;

        const { mainPatientName, subpatients, entityId, showSubPatient } =
            this.state;

        const mainPatientNameString = `${mainPatientName} ${SELECT_PATIENT_STRINGS.MyNameIndicator}`;

        const childProps = {
            emailErrorMessage,
            nameErrorMessage,
            showDateError,
            providerId,
            locationId,
            procedureId,
            appointmentTime,
            mainPatientName: mainPatientNameString,
            mainPatientId,
            subpatients,
            entityId,
            showSubPatient,
            onPatientChange: this.handlePatientChange,
            onContinue: this.handleContinue,
            onSubpatientCreated: this.handleSubpatientCreated,
            disableContinue: !(entityId > 0),
            trackClickContinue,
            trackMePatientFieldSelect,
            trackNewSubPatientFieldSelect,
            trackExistingSubPatientFieldSelect,
        };

        const childrenWithProps = React.Children.map(
            this.props.children,
            (child) =>
                React.cloneElement(child, {
                    ...this.props,
                    selectPatient: { ...childProps },
                    children: child.props.children,
                })
        );

        return <div>{childrenWithProps}</div>;
    }
}

export default SelectPatientStateManager;
